import React from 'react'

import TutorialMapContainer from './TutorialMapContainer'

const TutorialMapScreen = () => (
  <React.Fragment>
    <TutorialMapContainer />
  </React.Fragment>
)

export default TutorialMapScreen
